import { z } from 'zod';

import { UserDtoScheme } from '~modules/user/model';

export const AuthDtoScheme = z.object({
	token: z.string().describe('JWT токен'),
	user: UserDtoScheme.describe('Пользователь'),
});

export type AuthDto = z.infer<typeof AuthDtoScheme>;

export const AuthReqKeycloakDtoScheme = z.object({ access_token: z.string().describe('Access токен от Keycloak') });

export type AuthReqKeycloakDto = z.infer<typeof AuthReqKeycloakDtoScheme>;

export const AuthReqDeviceCoordsDtoScheme = z.object({
	lat: z.number().describe('Широта'),
	lon: z.number().describe('Долгота'),
});

export type AuthReqDeviceCoordsDto = z.infer<typeof AuthReqDeviceCoordsDtoScheme>;

export const AuthReqDeviceDtoScheme = z.object({
	qr: z.string().describe('QR код'),
	coords: AuthReqDeviceCoordsDtoScheme.optional().nullable().describe('Координаты'),
});

export type AuthReqDeviceDto = z.infer<typeof AuthReqDeviceDtoScheme>;
